/* tslint:disable */
/* eslint-disable */
/**
 * EM2
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ForumFeedBackGroupType } from '../apiModels';
// @ts-ignore
import { ItineraryItemType } from '../apiModels';
// @ts-ignore
import { ObjectNotFoundExceptionResponse } from '../apiModels';
/**
 * ForumFeedbackApi - axios parameter creator
 * @export
 */
export const ForumFeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export forum feedbacks
         * @param {number} forumId ForumId
         * @param {ForumFeedBackGroupType} [group] 
         * @param {ItineraryItemType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumForumIdFeedbackExportGet: async (forumId: number, group?: ForumFeedBackGroupType, type?: ItineraryItemType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forumId' is not null or undefined
            assertParamExists('forumForumIdFeedbackExportGet', 'forumId', forumId)
            const localVarPath = `/forum/{forumId}/feedback/export`
                .replace(`{${"forumId"}}`, encodeURIComponent(String(forumId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (group !== undefined) {
                localVarQueryParameter['Group'] = group;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForumFeedbackApi - functional programming interface
 * @export
 */
export const ForumFeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForumFeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export forum feedbacks
         * @param {number} forumId ForumId
         * @param {ForumFeedBackGroupType} [group] 
         * @param {ItineraryItemType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumForumIdFeedbackExportGet(forumId: number, group?: ForumFeedBackGroupType, type?: ItineraryItemType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumForumIdFeedbackExportGet(forumId, group, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ForumFeedbackApi - factory interface
 * @export
 */
export const ForumFeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForumFeedbackApiFp(configuration)
    return {
        /**
         * 
         * @summary Export forum feedbacks
         * @param {ForumFeedbackApiForumForumIdFeedbackExportGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumForumIdFeedbackExportGet(requestParameters: ForumFeedbackApiForumForumIdFeedbackExportGetRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.forumForumIdFeedbackExportGet(requestParameters.forumId, requestParameters.group, requestParameters.type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for forumForumIdFeedbackExportGet operation in ForumFeedbackApi.
 * @export
 * @interface ForumFeedbackApiForumForumIdFeedbackExportGetRequest
 */
export interface ForumFeedbackApiForumForumIdFeedbackExportGetRequest {
    /**
     * ForumId
     * @type {number}
     * @memberof ForumFeedbackApiForumForumIdFeedbackExportGet
     */
    readonly forumId: number

    /**
     * 
     * @type {ForumFeedBackGroupType}
     * @memberof ForumFeedbackApiForumForumIdFeedbackExportGet
     */
    readonly group?: ForumFeedBackGroupType

    /**
     * 
     * @type {ItineraryItemType}
     * @memberof ForumFeedbackApiForumForumIdFeedbackExportGet
     */
    readonly type?: ItineraryItemType
}

/**
 * ForumFeedbackApi - object-oriented interface
 * @export
 * @class ForumFeedbackApi
 * @extends {BaseAPI}
 */
export class ForumFeedbackApi extends BaseAPI {
    /**
     * 
     * @summary Export forum feedbacks
     * @param {ForumFeedbackApiForumForumIdFeedbackExportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumFeedbackApi
     */
    public forumForumIdFeedbackExportGet(requestParameters: ForumFeedbackApiForumForumIdFeedbackExportGetRequest, options?: AxiosRequestConfig) {
        return ForumFeedbackApiFp(this.configuration).forumForumIdFeedbackExportGet(requestParameters.forumId, requestParameters.group, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
}

